<script setup>
import { RouterView } from 'vue-router';
</script>
<template>
<RouterView></RouterView>
</template>
<style scoped>
</style>